import { FormGroupState } from '@shared/models/common';
import { MesEtablissementSearchForm } from '@features/compte/mes-etablissements/features/mes-etablissements-table/models/mes-etablissements-search-form';
import { createReducer, on } from '@ngrx/store';
import { MesEtablissementSearchFormActions } from '@features/compte/mes-etablissements/features/mes-etablissements-table/search/search.action';

export const featureKey = 'mesEtablissementsSearcheForm';

export interface MesEtablissementSearchFormActionsState
  extends FormGroupState<MesEtablissementSearchForm> {
  resetDone: boolean;
  orderBy: string;
  orderByColumn: string;
}

export const initialState: MesEtablissementSearchFormActionsState = {
  value: new MesEtablissementSearchForm(),
  checkingForm: false,
  isValid: false,
  errorMessage: null,
  errors: [],
  resetDone: true,
  orderBy: 'asc',
  orderByColumn: 'raisonSociale',
};

export const MesEtablissementSearchFormReducers = createReducer(
  initialState,
  on(MesEtablissementSearchFormActions.updateSearchForm, (state, { form }) => ({
    ...state,
    value: form,
    page: form.page,
    pageSize: form.pageSize,
  })),

  on(MesEtablissementSearchFormActions.resetSearchForm, (state) => ({
    ...state,
    value: new MesEtablissementSearchForm(),
  })),

  on(MesEtablissementSearchFormActions.resetDone, (state, { resetDone }) => ({
    ...state,
    resetDone,
  })),
  on(MesEtablissementSearchFormActions.updateSort, (state, { orderBy, orderByColumn }) => ({
    ...state,
    orderBy,
    orderByColumn,
  })),
);
